export default __webpack_public_path__ + "static/media/press_5.ffad1c93.webp";